import React from 'react';
import { Button } from '@wds/button';

import useTrackingDetails from '~pricing/hooks/useTrackingDetails';

import useCta from '~pricing/hooks/useCta';
import { generateCTAMetricsAttribute } from '~pricing/pages/shared/index';
import { PackageIds } from '~shared/constants/pricing';
import { PackageCTAProps } from './types';

import useStyles from './useStyles';
import { usePricingState } from '~shared/hooks/usePricingState';

const PackageCta = ({ packageName, isSummaryPage = false, className = '' }: PackageCTAProps): JSX.Element => {
  const {
    state: {
      packages: { getPackageById },
    },
  } = usePricingState();

  const { CTA, noCTA } = useStyles({ packageName });
  const packageId = PackageIds[packageName];
  const { pageName } = useTrackingDetails();
  const { isEnabled, ctaUrl, ctaLabel } = useCta(getPackageById(packageId));
  const buttonWrapperClassName = `${className} ${isEnabled ? CTA : noCTA}`;

  return (
    <div className={buttonWrapperClassName}>
      <Button
        data-sm-metrics={generateCTAMetricsAttribute({
          pageName,
          packageId: `${packageId}`,
          packageName, // lowercase canonical_name
        })}
        color={isEnabled ? 'primary' : 'secondary'}
        href={ctaUrl}
        variant={isEnabled ? 'solid' : 'text'}
        disabled={!isEnabled}
        data-testid="PackageCta__Btn"
        size={isSummaryPage ? 'md' : 'sm'}
      >
        {ctaLabel}
      </Button>
    </div>
  );
};

export default PackageCta;
